module.exports = {"id":"213814","name":"Federico Di Francesco","rating":"76","photo":"./data/images/photos/0/213814.png","club":{"name":"Bologne","logo":"./data/images/clubs/Bologne.png"},"positions":["AG","AD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FedericoDiFrancesco0.json
// module id = 1378
// module chunks = 0